// components/mention/UserMentionPicker.jsx
import React, { useEffect, useState, useMemo } from 'react';
import { Form, Spinner, Badge, Button } from 'react-bootstrap';
import { FiAtSign, FiX } from 'react-icons/fi';
import { fetchLabUsers } from '../../api/chatApi';

const getMyId = () => {
  try {
    const u = JSON.parse(localStorage.getItem('userData') || '{}');
    return String(u._id || u.userId || localStorage.getItem('userId') || '');
  } catch {
    return '';
  }
};

export default function UserMentionPicker({ selected = [], onChange }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const myId = getMyId();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchLabUsers();
        if (!cancelled && data.success) {
          setUsers(
            (data.users || []).filter((u) => String(u._id) !== myId)
          );
        }
      } catch {
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [myId]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return users.slice(0, 8);
    return users
      .filter((u) => {
        const name = `${u.first_name || ''} ${u.last_name || ''} ${u.username || ''} ${u.email || ''}`.toLowerCase();
        return name.includes(q);
      })
      .slice(0, 12);
  }, [users, search]);

  const isSelected = (id) => selected.some((s) => String(s.userId) === String(id));

  const toggle = (u) => {
    const id = String(u._id);
    if (isSelected(id)) {
      onChange(selected.filter((s) => String(s.userId) !== id));
    } else {
      onChange([
        ...selected,
        {
          userId: u._id,
          userName:
            [u.first_name, u.last_name].filter(Boolean).join(' ').trim() ||
            u.username ||
            u.email ||
            'User'
        }
      ]);
    }
  };

  return (
    <div>
      <div className="d-flex flex-wrap gap-1 mb-1">
        {selected.map((s) => (
          <Badge
            key={s.userId}
            bg="info"
            className="d-inline-flex align-items-center gap-1"
            style={{ fontSize: 12 }}
          >
            @{s.userName}
            <FiX
              role="button"
              style={{ cursor: 'pointer' }}
              onClick={() =>
                onChange(selected.filter((x) => String(x.userId) !== String(s.userId)))
              }
            />
          </Badge>
        ))}
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => setOpen((v) => !v)}
          type="button"
        >
          <FiAtSign /> Mention
        </Button>
      </div>

      {open && (
        <div
          style={{
            border: '1px solid #e9ecef',
            borderRadius: 4,
            padding: 8,
            maxHeight: 220,
            overflowY: 'auto'
          }}
        >
          {loading ? (
            <Spinner size="sm" animation="border" />
          ) : (
            <>
              <Form.Control
                size="sm"
                placeholder="Search users..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="mb-2"
              />
              {filtered.length === 0 ? (
                <div className="text-muted small">No users found</div>
              ) : (
                filtered.map((u) => (
                  <Form.Check
                    key={u._id}
                    type="checkbox"
                    id={`mention-${u._id}`}
                    label={
                      [u.first_name, u.last_name].filter(Boolean).join(' ') ||
                      u.username ||
                      u.email ||
                      'User'
                    }
                    checked={isSelected(u._id)}
                    onChange={() => toggle(u)}
                  />
                ))
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}